import { AssignStationControl } from "../subcontrol/AssignStationControl";
import { AssignEavesBoardControl } from "../subcontrol/AssignEavesBoardControl";
import { AssembleRoofSlapControl } from "../subcontrol/AssembleRoofSlapControl";
import { AssignGutterControl } from "../subcontrol/AssignGutterControl";
import { DrawSectionControl } from "../subcontrol/DrawSectionControl";
import { DrawRoamRouteControl } from "../subcontrol/DrawRoomRouteControl";


export const ARCHI_SUB_CONTROL = {
    /**
     * 布置站台二级控制器
     */
    ASSIGNSTATIONCONTROL: { name: "ASSIGNSTATIONCONTROL", needInit: true, cmd: "AssignStationControl", clazz: AssignStationControl },
    /**
     * 布置柱二级控制器
     */
    // ASSIGNCOLUMNCONTROL: { name: "ASSIGNCOLUMNCONTROL", needInit: true, cmd: "AssignColumnControl", clazz: AssignColumnControl },
    /**
     * 绘制屋面板截面控制器
     */
    DRAWSECTIONCONTROL: { name: "DRAWSECTIONCONTROL", cmd: "DrawSectionControl", clazz: DrawSectionControl },
    /**
     * 布置屋面板控制器
     */
    ASSEMBLEROOFSLAP: { name: "ASSEMBLEROOFSLAP", cmd: "AssembleRoofSlapControl", clazz: AssembleRoofSlapControl },
    /**
     * 布置檐口板二级控制器
     */
    ASSIGNEAVESBOARDCONTROL: { name: "ASSIGNEAVESBOARDCONTROL", cmd: "AssignEavesBoardControl", clazz: AssignEavesBoardControl },
    /**
     * 布置天沟二级控制器
     */
    ASSIGNGUTTERCONTROL: { name: "ASSIGNGUTTERCONTROL", needInit: true, cmd: "AssignGutterControl", clazz: AssignGutterControl },
    // /**
    //  * 覆盖array二级控制器
    //  */
    // ARRAY: { name: "ARRAY", cmd: "ArrayControl", clazz: MonixArrayControl },
    // /**
    //  * 布置路灯、树等组件二级控制器
    //  */
    // ADDBUILDINGCOMPONENTCONTROL: { name: "ADDBUILDINGCOMPONENTCONTROL", cmd: "AddBuildingComponentControl", clazz: AddBuildingComponentControl },
    /**
     * 绘制漫游路线二级控制器
     */
    DRAWROAMROUTECONTROL: { name: "DRAWROAMROUTECONTROL", needInit: true, cmd: "DRAWROAMROUTECONTROL", clazz: DrawRoamRouteControl },
}